import script from "./InputDate.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputDate.vue?vue&type=script&lang=ts&setup=true"

import "./InputDate.vue?vue&type=style&index=0&id=cb411a46&lang=less"

const __exports__ = script;

export default __exports__